module.exports = __webpack_public_path__ + "img/y3.879f1db2.png";